import logo from './logo.svg';
import './App.css';
import config from './config';
import React, { useContext, useState, useEffect, useReducer } from 'react';
import { rootlink, URL_MW, thumbnailConfig, blue } from './config';
import { AiOutlineSearch } from "react-icons/ai";
import './css/common.scss';
import './css/bulma-tune.scss';
/////////////// swiper start 
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs } from 'swiper/core';
import loadingicon from './img/loading.gif';
import { Navigation, Pagination, Scrollbar, A11y, Lazy } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
/////////////// swiper end 
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import $ from "jquery";
import BgImage from './BgImage';

var ts = 0;

const GALLERY_ASPECT_RATIO = `${thumbnailConfig.width}/${thumbnailConfig.height}`;
const PLAN_ASPECT_RATIO = '4/3';
const MORE_VIEW_ASPECT_RATIO = '640/400';
const PHOTO_SKELETON_ROWS = 2;
const MORE_VIEW_SKELETON_SLIDES = 3;

const PhotoPlaceholder = () => (
  <BgImage aspectRatio={GALLERY_ASPECT_RATIO} aria-hidden="true" />
);

const PlanPlaceholder = () => (
  <BgImage aspectRatio={PLAN_ASPECT_RATIO} fit="contain" aria-hidden="true" />
);

const MoreViewSkeletonCard = ({ labelMinHeight = '24px' }) => (
  <div className="card" aria-hidden="true">
    <BgImage aspectRatio={MORE_VIEW_ASPECT_RATIO} />
    <div className="card-content" style={{ paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px", minHeight: '46px' }}>
      <div style={{ lineHeight: labelMinHeight, fontSize: "24px", minHeight: labelMinHeight }}>{'\u00A0'}</div>
    </div>
  </div>
);

const BranchSkeleton = () => (
  <div className='my-1' aria-hidden="true">
    <div className="branch_items py-2 px-2" style={{ minHeight: '88px' }}>
      <table>
        <tbody>
          <tr><th colSpan={2}><span className="branch_name" style={{ color: "#4286f4", fontSize: "16px" }}>{'\u00A0'}</span></th></tr>
          <tr>
            <td style={{ minWidth: "50px" }}><span style={{ color: "#808080", fontSize: "14px" }}>電話：</span></td>
            <td><span style={{ color: "#4286f4", fontSize: '16px' }}>{'\u00A0'}</span></td>
          </tr>
          <tr>
            <td style={{ minWidth: "50px" }}><span style={{ color: "#808080", fontSize: "14px" }}>地址：</span></td>
            <td><span style={{ color: "#4286f4", fontSize: "12px" }}>{'\u00A0'}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr className='hr2' />
  </div>
);

const AppDesktop = ({ loaded, viewinfo, photolist, planlist, branchlist }) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const viewid = searchParams.get("id");

  const navigate = useNavigate();

  function golink(p) {
    var url = rootlink + "details?id=" + p['value'];
    window.open(url, '_blank');
  }

  function ltrbox(action) {
    if (action == "show") {
      // document.getElementById('lightrail').style.display = 'block';
      $("#lightrail").fadeIn(500);
    } else {
      // document.getElementById('lightrail').style.display = 'none';
      $("#lightrail").fadeOut(500);
    }
  }

  var photolist3d = [];
  if (photolist != null) {
    for (var i = 0; i < photolist.length; i += 4) {
      photolist3d.push([photolist[i], photolist[i + 1], photolist[i + 2], photolist[i + 3]]);
    }
  }

  var planslist3d = [];
  if (planlist != null) {
    for (var i = 0; i < planlist.length; i += 4) {
      planslist3d.push([planlist[i], planlist[i + 1], planlist[i + 2], planlist[i + 3]]);
    }
  }

  console.log(planslist3d)

  return (
    <div className="content_desktop container"
      style={{ padding: "20px 40px" }}
    >
      <div className="top_options" style={{
        marginBottom: "10px",
        display: "flex",
        justifyContent: "flex-end"
      }}>
        {/* <div className="opt_back">
          <span
            onClick={() => navigate(-1)}
            style={{
              cursor: "pointer",
              padding: "5px 7px",
              background: blue,
              color: "white",
              border: "1px transparent",
              borderRadius: "6px"
            }}>返回</span>
        </div> */}
      </div>
      <div className="row">
        <div className="basic_info col-md-12 mb-5">
          {/* <hr className="hr1" /> */}
          <div className='main_bg_color'>
            <table
              className="table table-hover w-100 text-left info-table table-condensed"
              style={{ marginBottom: "0", maxHeight: "500px", height: "100%" }}>
              <tbody>
                <tr><th colSpan={2}>基本資料({loaded ? viewinfo['auto_no'] : '\u00A0'})</th></tr>
                <tr>
                  <td className="info_label">物業地址：</td>
                  <td>{loaded ? viewinfo['address'] : '\u00A0'}</td>
                </tr>
                <tr>
                  <td className="info_label">間格：</td>
                  <td>{loaded ? viewinfo['layoutLine'] : '\u00A0'}</td>
                </tr>
                <tr>
                  <td className="info_label">類型：</td>
                  <td>{loaded ? viewinfo['prop_type'] : '\u00A0'}</td>
                </tr>
                {loaded && viewinfo['area_field'] != "" ? <tr>
                  <td className="info_label">面積:</td>
                  <td>這個樓盤資料只供參考，並不代表發售，如要查看這屋苑的面積資料,請點擊<a target='_blank' href={URL_MW + '/view/NEW/plan_mw.php?bldgname=' + viewinfo['cbldgname']}>這裡.</a></td>
                </tr>
                  : null}
                {/* {(viewinfo['LineTable'] != "" && viewinfo['stationfield'] != "") ?
                  <tr>
                    <td style={{ minWidth: "125px" }}>鄰近輕鐵站：</td>
                    <td>
                      <div
                        id='lightrail'
                        style={{ display: "block", width: '472px', height: 'auto', backgroundColor: 'white', position: 'fixed', zIndex: '5', border: '2px solid rgb(33 144 255)', left: "0px", right: "0px", marginLeft: "auto", marginRight: "auto" }}>
                        <table cellSpacing={0} cellPadding={0} width='472px' className='stTitle'>
                          <tbody>
                            <tr>
                              <td className='heading'><a onClick={() => { ltrbox('hide') }} style={{ color: 'blue', cursor: 'pointer' }}>關閉</a></td>
                              <td align='center' className='heading' style={{ width: "75px" }}>輕鐵路線</td>
                            </tr>
                            <tr>
                              <td className='theadingC'>路線</td>
                              <td className='theadingC' colSpan={2}>途經車站</td>
                            </tr>
                            {viewinfo["LineTable"].map(p => {
                              <tr>
                                <td className='theadingC' valign='top'>{p['theline']}</td>
                                <td className='content'>{p['stations']}</td>
                              </tr>
                            })}
                          </tbody>
                        </table>
                      </div><a onClick={() => { ltrbox('show') }} style={{ color: 'blue', cursor: 'pointer' }}>天秀</a></td>
                  </tr>
                  : null} */}
              </tbody>
            </table>
          </div>
        </div>
        <div className="photo_list col-md-12 mb-5">
          <div id="photo_desktop" className="prop_tab tab_selected position-relative">
            <span>單位相片</span><span className="text-danger">(相片由業主提供)</span>
            <a className='float-end'
              href={rootlink + "gallery?id=" + viewid}
              target="_blank"
              style={{
                backgroundColor: 'rgb(66 137 244)',
                color: '#fff',
                padding: '0px 8px',
                border: 'none',
                borderRadius: '5px',
                position: 'absolute',
                right: '0',
                bottom: '2px',
              }}>
              <AiOutlineSearch size={30} style={{ paddingBottom: '4px' }} />地氈式睇樓</a>
          </div>
          <hr className="hr1"></hr>
          <hr className="hr1"></hr>
          <table style={{ border: "2px solid #99CCFF", width: "100%" }}>
            <tbody>
              {!loaded || !photolist?.length ? (
                Array.from({ length: PHOTO_SKELETON_ROWS }).map((_, row) => (
                  <tr key={'photo_placeholder_row_' + row}>
                    {[0, 1, 2, 3].map(x => (
                      <td
                        className="px-3 py-3 photolist_items"
                        style={{ borderCollapse: "collapse", border: "1px solid #CCCCCC", width: '25%' }}
                        key={"photo_placeholder_" + row + "_" + x}
                      >
                        <PhotoPlaceholder />
                      </td>
                    ))}
                  </tr>
                ))
              ) : photolist3d.map((p, i) => {
                return <tr key={'photolist_' + i}>
                  {[0, 1, 2, 3].map(x => (
                    <td className="px-3 py-3 photolist_items"
                      style={{ borderCollapse: "collapse", border: "1px solid #CCCCCC", width: '25%' }}
                      key={"photo_" + i + "_" + x}>
                      {p[x] !== undefined ? (
                        <>
                          <a data-fancybox="gallery1" rel='photo_list'
                            data-caption={p[x]['type']}
                            data-src={URL_MW + "resize_img_3g.php?flag=1&img=" + p[x]['file_name'] + "&width=" + thumbnailConfig.width + "&height=" + thumbnailConfig.height}  >
                            <BgImage
                              src={URL_MW + "resize_img_3g.php?flag=1&img=" + p[x]['file_name'] + "&width=" + thumbnailConfig.width + "&height=" + thumbnailConfig.height}
                              aspectRatio={GALLERY_ASPECT_RATIO}
                              fit="cover"
                              alt={p[x]['type'] || ''}
                            />
                          </a>
                          <div className='position-relative'>
                            <span className="text-center"
                              style={{
                                position: "absolute",
                                bottom: "-3px",
                                right: "0px",
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "20px",
                                textShadow: "1px 1px black"
                              }}>{p[x]['type']}</span>
                          </div>
                        </>
                      ) : (
                        <PhotoPlaceholder />
                      )}
                    </td>
                  ))}
                </tr>
              })}
            </tbody>
          </table>
        </div>
        {/* 圖則 */}
        {(!loaded || planslist3d.length > 0) ? (
          <div className="plans_list col-md-12 mb-5">
            <div id="plans_desktop" className="prop_tab tab_selected"> 圖則</div>
            <hr className="hr1"></hr>
            <hr className="hr1"></hr>
            <table className="w-100">
              <tbody>
                {!loaded ? (
                  <tr>
                    {[0, 1, 2, 3].map(x => (
                      <td
                        className="px-3 py-3 planslist_items"
                        style={{ width: "25%", borderCollapse: "collapse", border: "1px solid #CCCCCC" }}
                        key={"plans_placeholder_" + x}
                      >
                        <PlanPlaceholder />
                      </td>
                    ))}
                  </tr>
                ) : planslist3d.map((p, i) => {
                  return <tr key={'planslist_' + i}>
                    {[0, 1, 2, 3].map(x => (
                      <td className="px-3 py-3 planslist_items"
                        style={{ width: "25%", borderCollapse: "collapse", border: "1px solid #CCCCCC" }}
                        key={"plans_" + i + "_" + x}>
                        {p[x] !== undefined ? (
                          <a data-fancybox="gallery2" rel='plans_list'
                            data-src={URL_MW + p[x]['file_name']}  >
                            <BgImage
                              src={URL_MW + p[x]['file_name']}
                              aspectRatio={PLAN_ASPECT_RATIO}
                              fit="contain"
                              alt=""
                            />
                          </a>
                        ) : (
                          <PlanPlaceholder />
                        )}
                      </td>
                    ))}
                  </tr>
                })}
              </tbody>
            </table>
            {/* <Swiper
              modules={[Navigation, Pagination, A11y, Lazy]}
              spaceBetween={0}
              slidesPerView={1}
              lazy={true}
              navigation
              // onClick={() => { golink(p) }}
              pagination={{ clickable: true }}
            // onSwiper={() => { console.log('next') }}
            //onSwiper={(swiper) => console.log(swiper)}//
            //onSlideChange={(i) => console.log('slide change',i, i.key ,i.counter )}
            >
              {plans_list
                .map(x => {
                  if (typeof x == 'string') return { url: x };
                  return {
                    url: URL_MW + x['file_name'],
                  }
                }
                ).map((p2, index) => {
                  //return <img src={p2['url']} />
                  // return <SwiperSlide key={'swiper' + index}>
                  //     <a data-fancybox="gallery" rel='plan_list' data-src={p2['url']}  >
                  //         <div className='w-100 ratio ratio-4x3'>
                  //             <img loading='lazy' className='noselect img-fluid' src={p2['url']} />
                  //         </div>
                  //     </a>
                  // </SwiperSlide>
                })}
            </Swiper> */}
          </div>
        )
          : null
        }
        {/* 鄰近分行 */}
        {(!loaded || (branchlist != null && branchlist.length > 0)) ? (
          <div className="branch_list col-md-12 mb-5">
            <div id="branch_desktop" className="prop_tab tab_selected"> 鄰近分行</div>
            <hr className="hr1"></hr>
            <hr className="hr1"></hr>
            {!loaded ? (
              <BranchSkeleton />
            ) : branchlist.map(p => {
              //return <img src={p2['url']} />
              return (
                <div className='my-1' key={"branchlist_" + p['license']}>
                  <div className="branch_items py-2 px-2">
                    <table>
                      <tbody>
                        <tr><th colSpan={2}><span className="branch_name" style={{ color: "#4286f4", fontSize: "16px" }}>{p['name']}</span></th></tr>
                        <tr>
                          <td style={{ minWidth: "50px" }}><span style={{ color: "#808080", fontSize: "14px" }}>電話：</span></td>
                          <td><span style={{ color: "#4286f4", fontSize: '16px' }}>
                            <a style={{ color: '#4286f4', fontSize: '16px' }} href={`tel:${p['tel']}`}>{p['tel']}</a>
                          </span></td>
                        </tr>
                        <tr>
                          <td style={{ minWidth: "50px" }}> <span style={{ color: "#808080", fontSize: "14px" }}>地址：</span></td>
                          <td>  <span style={{ color: "#4286f4", fontSize: "12px" }}>{p['address']}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <hr className='hr2' />
                </div>
              );
            })}
          </div>
        ) : null}
        {(viewinfo['place_id'] !== undefined) ? (
          <div className="google_map col-md-12 mb-5">
            <div id="google_map" className="prop_tab tab_selected"> Google地圖</div>
            <hr className="hr1"></hr>
            <hr className="hr1"></hr>
            <iframe
              className='mt-2'
              id='map_iframe'
              frameBorder="0"
              style={{ border: "0", display: "block", width: "100%", height: "400px", border: "2px solid #99CCFF", borderBottom: "0px solid black", marginBottom: "0px" }}
              src={"https://www.google.com/maps/embed/v1/place?key=AIzaSyALt1dNayuRg_wlGqfl6rc6sUzF_mJgLlA&q=place_id:" + viewinfo['place_id']}
              // src={"https://www.google.com/maps/embed/v1/place?key=AIzaSyALt1dNayuRg_wlGqfl6rc6sUzF_mJgLlA&q=place_id:ChIJ585arovwAzQRSgUSSvY5FJY"}
              allowFullScreen>
            </iframe>
          </div>
        ) : null}
        <div className="more_view col-md-12 mb-5">
          <div id="more_view" className="prop_tab tab_selected"> 更多單位</div>
          <hr className="hr1"></hr>
          <hr className="hr1"></hr>
          <Swiper
            modules={[Navigation, Pagination, A11y, Lazy]}
            spaceBetween={15}
            slidesPerView={3}
            lazy={true}
            navigation
            // onClick={() => { golink(p) }}
            pagination={{ clickable: true }}
          // onSwiper={() => { console.log('next') }}
          //onSwiper={(swiper) => console.log(swiper)}//
          //onSlideChange={(i) => console.log('slide change',i, i.key ,i.counter )}
          >
            {!loaded ? (
              Array.from({ length: MORE_VIEW_SKELETON_SLIDES }).map((_, index) => (
                <SwiperSlide key={"more_opt_skeleton_" + index}>
                  <MoreViewSkeletonCard />
                </SwiperSlide>
              ))
            ) : (viewinfo['more_option'] !== undefined) ? viewinfo['more_option'].map(p => {
              return (
                <SwiperSlide key={"more_opt_" + p['value']}>
                  <div className="" onClick={() => golink(p)}>
                    <div className="card">
                      <BgImage
                        className="pointer"
                        src={p['img']}
                        aspectRatio={MORE_VIEW_ASPECT_RATIO}
                        fit="cover"
                        alt={p['label'] || ''}
                        style={{ cursor: 'pointer' }}
                      />
                      <div className="card-content" style={{ paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px", border: "0px solid green", minHeight: '46px' }}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                          <div className="pointer FZH4B" onClick={() => golink(p)} style={{ lineHeight: "24px", fontSize: "24px", minHeight: "24px" }}>{p['label']}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            }) : null
            }
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default AppDesktop;
